export enum AuthorityCRM {
  CRM_QUESTION_VIEW = '10.2.1',
  CRM_QUESTION_CREATE = '10.2.2',
  CRM_QUESTION_DELETE = '10.2.3',
  CRM_QUESTION_UPDATE = '10.2.4',
  CRM_RESPONSE_REQUEST_VIEW = '10.3.1',
  CRM_RESPONSE_REQUEST_CREATE = '10.3.2',
  CRM_RESPONSE_REQUEST_DELETE = '10.3.3',
  CRM_RESPONSE_REQUEST_UPDATE = '10.3.4',
  CRM_ANSWER_RESPONSE_VIEW = '10.4.1',
  CRM_ANSWER_RESPONSE_CREATE = '10.4.2',
  CRM_ANSWER_RESPONSE_DELETE = '10.4.3',
  CRM_ANSWER_RESPONSE_UPDATE = '10.4.4',
  CRM_SENDOPTION_VIEW = '10.5.1',
  CRM_SENDOPTION_CREATE = '10.5.2',
  CRM_SENDOPTION_DELETE = '10.5.3',
  CRM_SENDOPTION_UPDATE = '10.5.4',
  CRM_EMAILTAG_VIEW = '10.6.1',
  CRM_EMAILTAG_CREATE = '10.6.2',
  CRM_EMAILTAG_UPDATE = '10.6.3',
  CRM_EMAILTAG_DELETE = '10.6.4',
  CRM_QUIZ_READ = '10.1.1',
  CRM_QUIZ_CREATE = '10.1.2',
  CRM_QUIZ_DELETE = '10.1.3',
  CRM_QUIZ_UPDATE = '10.1.4',
}
